import { userApiRequests } from 'utils/api-requests/user';
import { v4 } from 'uuid';

export enum Platform {
    IOS = 'ios',
    Android = 'android',
    Web = 'web',
}

const detectPlatform = (): Platform => {
    try {
        // @ts-expect-error Capacitor nie jest dostępny w wersji webowej
        if (window.Capacitor) {
            // @ts-expect-error Capacitor nie jest dostępny w wersji webowej
            const rawPlatform = window.Capacitor.getPlatform();

            switch (rawPlatform) {
            case 'ios':
                return Platform.IOS;
            case 'android':
                return Platform.Android;
            case 'web':
                return Platform.Web;
            default:
                return Platform.Web;
            }
        }
    } catch (error) {
        const errorId = v4();
        userApiRequests.logException(error as Error, errorId);

        return Platform.Web;
    }

    return Platform.Web;
};

export const usePlatform = (): Platform => {
    return detectPlatform();
};
